
import SideEffectLink from './global/SideEffectLink';
export default {
    name: 'Footer',
    components: { SideEffectLink },
};
